<template>
  <v-card @click="newTab(`/opportunities/${opportunity.id}`)" class="candidate opportunity-card mb-4"
    :height="$vuetify.breakpoint.xsOnly ? 330 : 200">
    <v-layout fill-height :column="$vuetify.breakpoint.xsOnly" :row="$vuetify.breakpoint.smAndUp"
      :wrap="$vuetify.breakpoint.smAndUp" :align-start="$vuetify.breakpoint.smAndUp">
      <v-flex xs2 sm5 style="padding: 0;" class="images-wrapper">
        <v-img :src="opportunity.coverImage || opportunity.organization.coverImage"
          :height="$vuetify.breakpoint.xsOnly ? 100 : 200" lazy-src="https://picsum.photos/10/6?image=1021"
          :class="themes.candidate.light.muted" aspect-ratio="1">
          <template slot="placeholder">
            <v-layout fill-height align-center justify-center ma-0>
              <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
            </v-layout>
          </template>
        </v-img>
        <div class="opportunity-card__logo">
          <v-avatar :color="themes.candidate.light.muted" size="52">
            <v-avatar slot="activator" v-if="opportunity.organization" color="white" size="50">
              <img :src="opportunity.organization.logo || '/img/missing/logos/organizations/original.png'
                " />
            </v-avatar>
          </v-avatar>
        </div>
      </v-flex>

      <v-flex xs10 sm7 class="pa-3">
        <v-layout column>
          <v-flex class="text-xs-right marker-image">
            <v-avatar size="30" @click.stop="handleMarkerClick">
              <img :src="markerImage" alt="Marker image" />
            </v-avatar>
          </v-flex>

          <v-flex xs12 sm8 class="text-xs-center text-sm-left py-2" :class="{ 'pr-4': $vuetify.breakpoint.smAndUp }">
            <div style="width: 100%; position: relative;">
              <div class="title pr-4" :class="{
                  'text-block': $vuetify.breakpoint.xsOnly,
                  nowrap: $vuetify.breakpoint.smAndUp,
                }">
                {{ opportunity.name }}
              </div>
            </div>
          </v-flex>

          <v-flex d-flex xs12 sm8 class="text-xs-center text-sm-left">
            <v-chip :textColor="themes.candidate.light[opportunityDateColor]" class="transparent" outline
              style="height: 12px;">
              <v-icon :color="themes.candidate.light[opportunityDateColor]" class="text-vertical-middle" left small>
                mdi-calendar
              </v-icon>
              <span v-if="isOpportunityOpen">
                Closes in <strong>{{ timeToClosingDate }} </strong>
              </span>
              <span v-else-if="willOpportunityOpen">
                Opens in <strong>{{ timeToOpeningDate }} </strong>
              </span>
              <span v-else-if="isOpportunityClosed">Applications closed</span>
            </v-chip>
          </v-flex>

          <v-flex d-flex xs12 sm8 class="text-xs-center text-sm-left">
            <v-chip class="transparent" outline style="height: 12px;">
              <v-icon class="text-vertical-middle" left small>
                mdi-city
              </v-icon>
              <span>
                {{ opportunity.organization.name }}
              </span>
            </v-chip>
          </v-flex>

          <v-flex d-flex xs12 sm8 class="text-xs-center text-sm-left pb-2">
            <v-chip class="transparent" outline style="height: 12px;">
              <v-icon class="text-vertical-middle" left small>
                mdi-account-multiple-plus
              </v-icon>
              <span> {{ totalIntake }}&nbsp;{{ totalIntake | pluralize('position') }} </span>
            </v-chip>
          </v-flex>

          <v-flex xs12 sm8 class="text-xs-right">
            <v-btn v-if="canApply" @click.stop="$emit('input:apply')" color="success" :block="$vuetify.breakpoint.xsOnly">
              {{ opportunity.type == 'event' ? 'RSVP' : 'Apply' }}
            </v-btn>

            <v-btn v-else @click="newTab(`/opportunities/${opportunity.id}`)" color="success" flat>
              <span class="font-weight-bold">View</span>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
// Mixins
import { OpportunityDates } from '@/mixins/OpportunityDates.js'
import { OpportunityMapMarkerImage } from '@/mixins/OpportunityMapMarkerImage.js'
import { managedQueryParameters } from '@/mixins/managedQueryParameters.js'

// Helpers
import _ from 'lodash'

export default {
  mixins: [OpportunityDates, OpportunityMapMarkerImage, managedQueryParameters],

  props: { opportunity: Object },

  computed: {
    totalIntake() {
      if (!_.get(this, 'opportunity.locations[0].intake')) return

      return _.get(this, 'opportunity.locations[0].intake')
    },

    canApply() {
      return this.isOpportunityOpen || this.willOpportunityOpen
    },
  },

  methods: {
    handleMarkerClick() {
      const popup = _.get(this, 'opportunity.locations[0].id');
      if (popup) {
        this.clearQueryParameters();
        this.$nextTick(() => {
          this.updateQueryParameters({ popup }, false);
        });
      }
    },
    newTab(uri) {
      if (!uri) return

      window.open(uri, '_blank')
    },
  },
}
</script>

<style lang="scss">
.candidate.opportunity-card {
  cursor: pointer;
  border-radius: 1rem;
  overflow: hidden;

  &:hover {

    .marker-image .v-avatar,
    .marker-image img {
      transform: translateY(-1px) scale(1.1);
      transition: all 0.2s ease;
    }
  }

  .opportunity-card__logo {
    position: absolute;
    top: 0px;
    left: 0px;
    margin: 16px;

    @media (max-width: 600px) {
      top: 70px;
      left: 50%;
      height: 100%;
      margin: 0px;
      transform: translateX(-50%);
    }
  }

  .text-block {
    overflow: hidden;
    position: relative;
    height: 40px;
    max-height: 40px;
    margin-right: -1em;
    padding-right: 1em;

    &:before {
      content: '';
      position: absolute;
      right: 0;
      bottom: 0;
      height: 1.4rem;
      width: 100%;

      background: linear-gradient(to right, rgba(255, 255, 255, 0) 55%, #fff);
    }

    &:after {
      content: '';
      position: absolute;
      right: 0;
      width: 1.4em;
      height: 1.5rem;
      background: white;
    }
  }

  .nowrap {
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis-word;

    &::after {
      content: ' ';
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;

      background: linear-gradient(to right, transparent 85%, #fff);
    }
  }

  .v-badge .v-badge__badge {
    width: 3rem;
    border-radius: 4px;
    top: 0px;
    left: 0px;
  }
}
</style>
